import icondelete from "../../assets/icons/submit_bill/delete_btn.svg";

export const styles = (theme) => {
  return {
    root: {
      width: "100%",
      backgroundColor: theme.palette.cards.backgroundColor,
      padding: "1px",
      marginBottom: theme.spacing(2),
      fontFamily: "Montserrat",
      height: "177px",
      overflow: "hidden",
      borderRadius: "4px",
      [theme.breakpoints.down(641)]: {
        height: "131px",
      },
      [theme.breakpoints.down(481)]: {
        height: "103px",
      },
      [theme.breakpoints.down(381)]: {
        height: "90px",
      },
      [theme.breakpoints.down(361)]: {
        height: "86px",
      },
      [theme.breakpoints.down(321)]: {
        height: "80px",
      },
      border: "1px solid #fece73",
      // boxShadow:
      //   "0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)",
    },
    imageContainer: {
      display: "inline-block",
      width: "177px",
      height: "177px",
      borderRadius: "4px",
      // backgroundColor: theme.palette.img.backgroundColor,
      [theme.breakpoints.down("641")]: {
        height: "129px",
        width: "131px",
      },
      [theme.breakpoints.down("481")]: {
        height: "101px",
        width: "103px",
      },
      [theme.breakpoints.down("381")]: {
        height: "89px",
        width: "86px",
      },
      [theme.breakpoints.down("361")]: {
        height: "84px",
        width: "86px",
      },
      [theme.breakpoints.down("321")]: {
        height: "78px",
        width: "80px",
      },
      "& img": {
        height: "100%",
        width: "100%",
        objectFit: "contain",
        objectPosition: "center",
      },
    },
    details: {
      display: "inline-block",
      padding: "9px 20px 7px 30px",
      fontFamily: "Montserrat",
      width: "calc(100% - 177px)",
      height: "100%",
      verticalAlign: "top",
      [theme.breakpoints.down("641")]: {
        width: "calc(100% - 131px)",
        padding: "5px 10px 0px 12px",
      },
      [theme.breakpoints.down("481")]: {
        // height: "103px",
        width: "calc(100% - 103px)",
      },
      [theme.breakpoints.down("381")]: {
        // height: "86px",
        width: "calc(100% - 86px)",
      },
      [theme.breakpoints.down("321")]: {
        // height: "80px",
        width: "calc(100% - 80px)",
      },
    },
    brandName: {
      fontWeight: "500",
      userSelect: "none",
      color: theme.palette.typography.texts.color,
      fontFamily: "Montserrat",
      fontSize: "16px",
      height: "17px",
      width: "90%",
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      "-webkit-line-clamp": 1,
      "-webkit-box-orient": "vertical",
      textAlign: "left",
      [theme.breakpoints.down(641)]: {
        fontSize: "14px",
        height: "15px",
        lineHeight: "1.2",
      },
      [theme.breakpoints.down(481)]: {
        fontSize: "12px",
        height: "13px",
        lineHeight: "1.25",
      },
      [theme.breakpoints.down(421)]: {
        fontSize: "11.5px",
      },
      [theme.breakpoints.down(401)]: {
        fontSize: "11px",
      },
      [theme.breakpoints.down(381)]: {
        fontSize: "10.5px",
        height: "11px",
        lineHeight: "1.07",
      },
      [theme.breakpoints.down(361)]: {
        fontSize: "10px",
      },
      [theme.breakpoints.down(321)]: {
        fontSize: "8px",
        height: "9px",
        lineHeight: "1.13",
      },
    },
    productName: {
      fontWeight: "600",
      color: theme.palette.typography.texts.color,
      fontFamily: "Montserrat",
      textAlign: "left",
      lineHeight: "1.5",
      overflow: "hidden",
      userSelect: "none",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      "-webkit-line-clamp": 2,
      "-webkit-box-orient": "vertical",
      width: "100%",
      paddingTop: "2px",
      fontSize: "20px",
      [theme.breakpoints.down("641")]: {
        fontSize: "18px",
        height: "48px",
      },
      [theme.breakpoints.down("481")]: {
        fontSize: "16px",
        height: "30px",
        lineHeight: "15px",
      },
      [theme.breakpoints.down("421")]: {
        fontSize: "13.5px",
        height: "30px",
        lineHeight: "14px",
      },
      [theme.breakpoints.down("401")]: {
        fontSize: "13px",
      },
      [theme.breakpoints.down("381")]: {
        lineHeight: "12px",
        height: "28px",
        fontSize: "12px",
      },
      [theme.breakpoints.down("361")]: {
        height: "24px",
        fontSize: "12px",
      },
      [theme.breakpoints.down("321")]: {
        lineHeight: "9px",
        fontSize: "10px",
        height: "20px",
      },
    },
    price_mall: {
      fontSize: "16px",
      textAlign: "left",
      lineHeight: 1.67,
      overflow: "hidden",
      userSelect: "none",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      fontFamily: "Montserrat",
      maxWidth: "50%",
      [theme.breakpoints.down(641)]: {
        fontSize: "14px",
        lineHeight: "1.66",
      },
      [theme.breakpoints.down(481)]: {
        fontSize: "12px",
        lineHeight: "1.43",
      },
      [theme.breakpoints.down(421)]: {
        fontSize: "11.5px",
      },
      [theme.breakpoints.down(401)]: {
        fontSize: "11px",
      },
      [theme.breakpoints.down(381)]: {
        fontSize: "10.5px",
        lineHeight: "1.25",
      },
      [theme.breakpoints.down(361)]: {
        fontSize: "10px",
      },
      [theme.breakpoints.down(321)]: {
        fontSize: "8px",
        lineHeight: "1.35",
      },
    },
    separator: {
      margin: "0px 18px",
      padding: "0px",
      userSelect: "none",
      fontSize: "16px",
      color: " #e4e4e4",
      lineHeight: 1,
      [theme.breakpoints.down("xs")]: {
        margin: "0px 8px",
        fontSize: "12px",
      },
    },
    plusRow: {
      // textTransform: 'uppercase',
      marginTop: "15px",
      userSelect: "none",
      fontFamily: "Montserrat",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      [theme.breakpoints.down("sm")]: {
        marginTop: "0px",
        "& .MuiTypography-body1": {
          lineHeight: 1,
        },
      },
    },
    rsp: {
      // textTransform: 'uppercase',
      fontSize: "16px",
      lineHeight: "1",
      fontFamily: "Montserrat",
      userSelect: "none",
      color: theme.palette.typography.texts.color,
      [theme.breakpoints.down(641)]: {
        fontSize: "14px",
        lineHeight: "0.98",
      },
      [theme.breakpoints.down(481)]: {
        fontSize: "13px",
        lineHeight: "1",
      },
      [theme.breakpoints.down(421)]: {
        fontSize: "12px",
      },
      [theme.breakpoints.down(401)]: {
        fontSize: "11.5px",
      },
      [theme.breakpoints.down(381)]: {
        fontSize: "10.5px",
      },
      [theme.breakpoints.down(361)]: {
        fontSize: "10px",
      },
      [theme.breakpoints.down(321)]: {
        fontSize: "8px",
      },
    },
    mgSmallClose: {
      margin: "0px 16px",
      fontSize: "16px",
      color: "#7e7e7e",
      [theme.breakpoints.down(641)]: {
        fontSize: "14px",
        lineHeight: "0.98",
        margin: "0px 10px",
      },
      [theme.breakpoints.down(481)]: {
        fontSize: "12px",
        lineHeight: "1",
        margin: "0px 6px",
      },
      [theme.breakpoints.down(421)]: {
        fontSize: "11.5px",
      },
      [theme.breakpoints.down(401)]: {
        fontSize: "11px",
      },
      [theme.breakpoints.down(381)]: {
        fontSize: "10.5px",
      },
      [theme.breakpoints.down(361)]: {
        fontSize: "10px",
      },
      [theme.breakpoints.down(321)]: {
        fontSize: "8px",
      },
    },
    price_points: {
      fontSize: "18px",
      userSelect: "none",
      color: theme.palette.primary.main,
      fontWeight: "bold",
      fontFamily: "Montserrat",
      [theme.breakpoints.down(641)]: {
        fontSize: "16px",
      },
      [theme.breakpoints.down(481)]: {
        fontSize: "14px",
      },
      [theme.breakpoints.down(421)]: {
        fontSize: "13.5px",
      },
      [theme.breakpoints.down(401)]: {
        fontSize: "13px",
      },
      [theme.breakpoints.down(381)]: {
        fontSize: "12.5px",
      },
      [theme.breakpoints.down(361)]: {
        fontSize: "12px",
      },
      [theme.breakpoints.down(321)]: {
        fontSize: "10px",
      },
    },
    price_mallName: {
      textAlign: "left",
      userSelect: "none",
      fontFamily: "Montserrat",
      lineHeight: 1,
      paddingBottom: "5px",
      margin: "5px 0 0 0",
      [theme.breakpoints.down(641)]: {
        marginTop: "2px",
        lineHeight: 0.5,
      },
    },
    img: {
      width: "30px",
      height: "30px",
      display: "inline-block",
      transition: ".12s",
      "-webkit-mask-size": "cover",
      "mask-size ": "cover",
      cursor: "pointer",
      [theme.breakpoints.down("xs")]: {
        width: "16px",
        height: "16px",
      },
      [theme.breakpoints.down("sm")]: {
        width: "20px",
        height: "20px",
      },
      [theme.breakpoints.down(450)]: {
        width: "14px",
        height: "14px",
      },
    },
    icondeleteCss: {
      backgroundColor: "#fece73",
      " -webkit-mask-image": `url(.${icondelete})`,
      "mask-image": `url(.${icondelete})`,
      mask: `url(.${icondelete}) no-repeat center / contain`,
      "-webkit-mask": `url(.${icondelete}) no-repeat center / contain`,
      opacity: 0.6,
      top: "3px",
      position: "relative",
      [theme.breakpoints.down(381)]: {
        top: "0px",
      },
    },
    rootChild: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start",
      height: "100%",
    },
    sub_content: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    pro_content: {
      display: "flex",
      justifyContent: "space-between",
    },
    point_cal: {
      display: "flex",
      justifyContent: "space-between",
    },
    productDetails: {
      width: "90%",
    },
    down_icon: {
      position: "absolute",
      pointerEvents: "none",
      right: "5px",
      top: "calc(50% - 4px)",
      [theme.breakpoints.down(641)]: {
        top: "calc(50% - 3px)",
      },
      [theme.breakpoints.down(481)]: {
        top: "calc(50% - 1.8px)",
      },
      [theme.breakpoints.down(381)]: {
        top: "calc(50% - 1.8px)",
      },
      [theme.breakpoints.down(321)]: {
        top: "calc(50% - 2.8px)",
      },
    },
    formControl: {
      "& :first-child": {
        paddingRight: "10px",
        paddingTop: "2px",
        [theme.breakpoints.down(381)]: {
          paddingTop: "0px",
        },
      },
      "& .MuiInputBase-input": {
        fontSize: "16px",
        color: theme.palette.typography.texts.color,
        fontWeight: "normal",
        fontFamily: "Montserrat",
        [theme.breakpoints.down(641)]: {
          fontSize: "14px",
        },
        [theme.breakpoints.down(481)]: {
          fontSize: "13px",
        },
        [theme.breakpoints.down(421)]: {
          fontSize: "12px",
        },
        [theme.breakpoints.down(401)]: {
          fontSize: "11px",
        },
        [theme.breakpoints.down(381)]: {
          fontSize: "9px",
        },
        [theme.breakpoints.down(361)]: {
          fontSize: "9px",
        },
        [theme.breakpoints.down(321)]: {
          fontSize: "9px",
        },
      },
      "& .MuiSelect-selectMenu": {
        padding: 0,
      },
      "& .MuiInputBase-input:focus": {
        backgroundColor: "unset",
      },
    },
    select_box: {
      display: "block",
      background: "#fff",
      border: "1px solid #e4e4e4",
      borderRadius: "4px",
      position: "relative",
      overflow: "hidden",
      height: "50px",
      width: "50px",
      [theme.breakpoints.down(641)]: {
        width: "48px",
        height: "26px",
      },
      [theme.breakpoints.down(481)]: {
        width: "44px",
        height: "24px",
      },
      [theme.breakpoints.down(421)]: {
        width: "40px",
        height: "24px",
      },
      [theme.breakpoints.down(381)]: {
        width: "34px",
        height: "19px",
      },
      [theme.breakpoints.down(321)]: {
        width: "34px",
        height: "20px",
      },
    },
    orderStatusValue: {
      fontSize: "16px",
      // lineHeight: 1.3,
      [theme.breakpoints.down("641")]: {
        fontSize: "14px",
      },
      [theme.breakpoints.down("481")]: {
        fontSize: "12px",
      },
      [theme.breakpoints.down("421")]: {
        fontSize: "11.5px",
      },
      [theme.breakpoints.down("401")]: {
        fontSize: "11px",
      },
      [theme.breakpoints.down("381")]: {
        fontSize: "10.5px",
      },
      [theme.breakpoints.down("361")]: {
        fontSize: "10px",
      },
      [theme.breakpoints.down("321")]: {
        fontSize: "8px",
      },
    },
    orderStatus: {
      borderWidth: "2px",
      borderRadius: "15px",
      borderStyle: "solid",
      padding: "1px 5px",
      position: "relative",
      // top: "16px",
      // right: "5px",
      // [theme.breakpoints.down("641")]: {
      //   top: "5px",
      //   borderWidth: "1px",
      // },
    },
  };
};
